import React, { useContext, useEffect, useState } from "react";
import { motion } from "framer-motion";
import { formatTimeToAMPM, getIncompleteGuest, guestDataToupdate } from "../utils/helperFunctions";
import { MdEdit } from "react-icons/md";
import { Mycontext } from "../context/context";
import GuestAndCheckInForm from "../components/GuestAndCheckInForm";
import ReactPaginate from "react-paginate";
import { useSearchParams } from "react-router-dom";


const IncompleteCheckinReport = ({role}) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const initialPage = parseInt(searchParams.get("page")) || 1;
  const [checkInData, setcheckInData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [editvalue, setEditvalue] = useState({});
  const [isEdit, setisEdit] = useState(false);
  const [summaryData, setSummaryData] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(initialPage);
  const {checkExtension,formToShow} = useContext(Mycontext);
  // const topRef = useRef(null);

  const fetchData = async (page = 1) => {
    try {
      setIsLoading(true);
      const params = {
        page
      };
      const response = await getIncompleteGuest(params);
      if (response.data.status) {
        setcheckInData(response.data.data);
        setTotalPages(response.data.pagination.totalPages);
        setSummaryData(response.data.count)
      }
    } catch (error) {
      console.error("Error fetching incomplete guest data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData(currentPage);
    // topRef.current?.scrollIntoView({ 
    //   behavior: 'smooth',
    //   block: 'start'
    // })
  }, [currentPage]);

  useEffect(() => {
    if (checkInData.length === 0 && currentPage > 1) {
      const previousPage = 1;
      setCurrentPage(previousPage);
      setSearchParams({ page: previousPage });
    }
  }, [checkInData, currentPage, setSearchParams]);

  const handlePageClick = ({ selected }) => {
    const newPage = selected + 1;
    setCurrentPage(newPage);
    setSearchParams({ page: newPage });
    // window.scrollTo(0, 0);
    requestAnimationFrame(() => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    });
  };

 
  const formatValidationFields = (checkIn) => {
    return (checkIn.validation?.errors || []).map((field) => {
      const otherGuestMatch = field.match(/otherGuests\[(\d+)\]\.(.+)/);
      if (otherGuestMatch) {
        const index = parseInt(otherGuestMatch[1], 10);
        const fieldName = otherGuestMatch[2];
        const guestName = `Guest ${index + 1}`;
        return `${guestName} → ${fieldName}`;
      }
      const parts = field.split(".");
      return parts[parts.length - 1]; 
    });
  };

  const handleEdit = async (checkIn) => {
    try {
      checkExtension("formA");
      const response = await guestDataToupdate(checkIn._id);
      if (response.data.status) {
        setEditvalue(response.data.data);
        setisEdit(true);
      }
    } catch (error) {
      console.error("Error fetching guest details:", error);
    }
  };
  

  return (
    // ref={topRef}
    <div className="p-4 md:p-6 bg-gray-50 " >
      <div className="container mx-auto mb-6 bg-gradient-to-r from-indigo-50 to-blue-50 rounded-xl shadow-sm overflow-hidden">
        <div className="p-6">
          <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-6 gap-4">
            <div>
              <h1 className="text-2xl md:text-3xl font-bold text-gray-800">
                Incomplete CheckIn Data
              </h1>
              <p className="text-sm text-gray-600 mt-1">
                Review and update guest check-in records with missing
                information
              </p>
            </div>
           </div>
        </div>

        <div className=" mx-auto bg-white shadow-sm overflow-hidden">
          <div className="p-4 md:p-6">
            {isLoading && checkInData.length === 0 ? (
              <div className="flex justify-center items-center h-64">
                <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-indigo-500"></div>
              </div>
            ) : checkInData.length === 0 ? (
              <div className="flex flex-col items-center justify-center py-12">
                <p className="mt-4 text-lg font-medium text-gray-500">
                  No incomplete checkIn data found
                </p>
              </div>
            ) : (
              <div className="overflow-x-auto rounded-lg border border-gray-200 shadow-md">
                <table className="min-w-full divide-y divide-gray-200">
                  <thead className="bg-gradient-to-r from-indigo-50 to-blue-50">
                    <tr>
                      <th className="px-6 py-3 text-left text-xs font-bold text-indigo-600 uppercase tracking-wider border-b border-indigo-100">
                        Room No
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-bold text-indigo-600 uppercase tracking-wider border-b border-indigo-100">
                        Guest Name
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-bold text-indigo-600 uppercase tracking-wider border-b border-indigo-100">
                        Check-In
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-bold text-indigo-600 uppercase tracking-wider border-b border-indigo-100">
                        Check-Out
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-bold text-indigo-600 uppercase tracking-wider border-b border-indigo-100">
                        Incomplete Fields
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-bold text-indigo-600 uppercase tracking-wider border-b border-indigo-100">
                        Actions
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200">
                    {checkInData.map((checkIn, index) => (
                      <motion.tr
                        key={checkIn._id}
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        className={`transition-colors duration-150 ${
                          index % 2 === 0 ? "bg-white" : "bg-indigo-50/30"
                        } hover:bg-indigo-100/30`}
                      >
                        <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                          {checkIn.roomNumber}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                         
                          
                          <div className="text-sm font-medium text-gray-900">
                            {checkIn.firstName} {"  "}
                            {checkIn.lastName}
                          </div>
                          
                        </td>

                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                          <div className="text-sm text-gray-900">
                            {formatTimeToAMPM(checkIn.checkInTime)}
                          </div>
                          <div className="text-xs text-gray-500">
                            {new Date(checkIn.checkInDate?.split("T")[0])
                              .toLocaleDateString("en-GB")
                              .replace(/\//g, "-")}
                          </div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                          {checkIn.checkOutTime ? (
                            <div>
                              <div className="text-sm text-gray-900">
                                {formatTimeToAMPM(checkIn.checkOutTime)}
                              </div>
                              <div className="text-xs text-gray-500">
                                {new Date(checkIn.checkOutDate?.split("T")[0])
                                  .toLocaleDateString("en-GB")
                                  .replace(/\//g, "-")}
                              </div>
                            </div>
                          ) : (
                            <span className="inline-block bg-yellow-100 text-yellow-800 text-xs font-semibold px-2 py-1 rounded">
                            Pending
                          </span>
                          )}
                        </td>

                        <td className="px-6 py-4 flex flex-wrap text-sm text-gray-900 max-w-lg 2xl:max-w-2xl">
                          {checkIn.validation?.errors
                            ? formatValidationFields(
                                checkIn
                              ).join(", ")
                            : "All Fields Complete"}
                        </td>

                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                        <button
                                onClick={() => handleEdit(checkIn)}
                                className="text-indigo-600 hover:text-indigo-900 p-1"
                                title="Edit"
                              >
                                <MdEdit className="h-6 w-6" />
                              </button>
                        </td>
                      </motion.tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
            {/* Combined Summary and Pagination Section */}
         {checkInData.length > 0 && (
            <div className="mt-6 flex flex-col sm:flex-row justify-between items-center gap-4 p-4 bg-white rounded-lg border border-gray-200 shadow-sm">
              {/* Summary on the left */}
              <div className="flex items-center gap-6">
                <div className="flex items-center gap-2">
                  <div className="p-2 bg-indigo-100 rounded-full">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-4 w-4 text-indigo-600"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"
                      />
                    </svg>
                  </div>
                  <div>
                    <p className="text-xs text-gray-500">Total Guests</p>
                    <p className="text-sm font-semibold text-indigo-600">
                      {summaryData}
                    </p>
                  </div>
                </div>
              </div>
              {/* Pagination */}
              <div className="flex justify-center select-none w-full sm:w-auto overflow-x-auto">
                <ReactPaginate
                  previousLabel={
                    <span className="flex items-center gap-1 text-indigo-600">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-4 w-4"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                      >
                        <path
                          fillRule="evenodd"
                          d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
                          clipRule="evenodd"
                        />
                      </svg>
                      <span>Previous</span>
                    </span>
                  }
                  nextLabel={
                    <span className="flex items-center gap-1 text-indigo-600">
                      <span>Next</span>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-4 w-4"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                      >
                        <path
                          fillRule="evenodd"
                          d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                          clipRule="evenodd"
                        />
                      </svg>
                    </span>
                  }
                  breakLabel={<span className="px-2">...</span>}
                  pageCount={totalPages}
                  marginPagesDisplayed={1}
                  pageRangeDisplayed={3}
                  onPageChange={handlePageClick}
                  containerClassName={"flex items-center gap-1 text-sm"}
                  pageClassName={"flex"}
                  pageLinkClassName={
                    "px-3 py-1.5 rounded-md border border-gray-200 hover:bg-gray-100 transition-colors duration-200 select-none"
                  }
                  activeLinkClassName={
                    "text-indigo-600 border-indigo-400 hover:bg-gradient-to-r hover:from-indigo-50 hover:to-blue-50 transition-colors duration-200"
                  }
                  previousClassName={"flex select-none"}
                  previousLinkClassName={
                    "px-3 py-1.5 rounded-md border border-indigo-400 hover:bg-gradient-to-r hover:from-indigo-50 hover:to-blue-50 transition-colors duration-200 flex items-center gap-1 select-none disabled:border-gray-300"
                  }
                  nextClassName={"flex select-none"}
                  nextLinkClassName={
                    "px-3 py-1.5 rounded-md border border-indigo-400 hover:bg-gradient-to-r hover:from-indigo-50 hover:to-blue-50 transition-colors duration-200 flex items-center gap-1 select-none disabled:border-gray-300"
                  }
                  breakClassName={"flex"}
                  breakLinkClassName={"px-2 py-1.5 select-none"}
                  disabledClassName={"opacity-50 cursor-not-allowed "}
                  disabledLinkClassName={"hover:bg-transparent text-gray-500"}
                  forcePage={currentPage - 1}
                />
              </div>
            </div>
          )}
          </div>
          
        </div>
         
      </div>
      {formToShow === "formA" && (
        <GuestAndCheckInForm
          action={fetchData}
          editvalue={editvalue}
          isEdit={isEdit}
          setEditvalue={setEditvalue}
          setisEdit={setisEdit}
          role={role}
        />
      )}
    </div>
  );
};

export default IncompleteCheckinReport;
